import { jsx as o } from "react/jsx-runtime";
import { useMultiStyleConfig as t, Link as c } from "@chakra-ui/react";
import { FacebookIcon as b, InstagramIcon as s, YouTubeIcon as k, XTwitterIcon as u, LinkedInIcon as m } from "../../icons/componentIcons.mjs";
import { Tooltip as I } from "../../overlay/Tooltip/Tooltip.mjs";
const r = ({
  "aria-label": n,
  icon: l,
  tooltip: e,
  ...a
}) => {
  const i = t("GlobalFooter");
  return /* @__PURE__ */ o("span", { role: "listitem", children: /* @__PURE__ */ o(I, { label: e || n, children: /* @__PURE__ */ o(c, { sx: i.socialsLink, "aria-label": n, ...a, children: l }) }) });
}, p = ({
  ...n
}) => /* @__PURE__ */ o(r, { icon: /* @__PURE__ */ o(b, {}), "aria-label": "Facebook", ...n }), T = ({
  ...n
}) => /* @__PURE__ */ o(r, { icon: /* @__PURE__ */ o(s, {}), "aria-label": "Instagram", ...n }), f = ({
  ...n
}) => /* @__PURE__ */ o(r, { icon: /* @__PURE__ */ o(k, {}), "aria-label": "YouTube", ...n }), g = ({
  ...n
}) => /* @__PURE__ */ o(r, { icon: /* @__PURE__ */ o(u, {}), "aria-label": "X", ...n }), h = ({
  ...n
}) => /* @__PURE__ */ o(r, { icon: /* @__PURE__ */ o(m, {}), "aria-label": "LinkedIn", ...n });
export {
  p as GlobalFooterFacebookLink,
  T as GlobalFooterInstagramLink,
  h as GlobalFooterLinkedInLink,
  r as GlobalFooterSocialLink,
  g as GlobalFooterXTwitterLink,
  f as GlobalFooterYouTubeLink
};
